const countryStateColors = {
  updated: '#08306B',
  updatedOffline: '#2171B5',
  old: '#238B45',
  oldOffline: '#74C476',
  noReport: '#969696'
};

const mapStyle = {
  positioning: {
    position: 'relative',
    width: '100%',
    height: '300px' /* hardcoded number, dynamic would be more elegant, but it's not that disturbing */
  },
  coloring: {
    borderColor: '#eee',
    fillColor: '#fff',
    nonMemberstateFill: '#fff'
  },
  highlighting: {
    highlightFillColor: '#3cc3ffa8',
    highlightBorderColor: '#eee'
  }
};

export default mapStyle;
export {
  countryStateColors
};



// WEBPACK FOOTER //
// ./src/components/Home/DataMap/mapStyle.js